<template>
  <div class="flow-flex-center jFlow">
    <div class="wrap">

      <div class="bullet-center fl-right">
        <router-link
          to="/flows">
          <i class="fa fa-times"/>
        </router-link>
      </div>

      <div class="bullet-center">
        <h2>Update Flow By Division</h2>
      </div>

      <jFormFlowType2
        ref="formFlowType2"
        mode="edit"
        @getData="getData"/>

      <b-row>
        <b-col>
          <div class="float-to-left m__t--50">
            <b-button
              class="btn red"
              @click="$refs.formFlowType2.validateForm()">
              Delete
            </b-button>
          </div>
        </b-col>

        <b-col>
          <div class="float-to-right m__t--50 m__l--24">
            <b-button
              class="btn blue"
              @click="sendData">
              Update
            </b-button>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import jFormFlowType2 from '@/components/form/flow/jFormFlowType2';
import { jMixModelEditFlowType2 } from '@/mixins/model/flow/jMixModelEditFlowType2';

export default {
  components: {
    jFormFlowType2,
  },

  mixins: [
    jMixModelEditFlowType2,
  ],

  data() {
    return {
      flow: null,
    };
  },

  methods: {
    getData(data) {
      this.flow = data;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/flow-rule/flow/edit/jFlowEditType2.vue